import React, { useEffect, useRef } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const MeetTheTeamPage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const currentSection = sectionRef.current;
    if (currentSection) {
      currentSection.style.opacity = '0';
      currentSection.style.transform = 'translateY(30px)';
      currentSection.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://monkstack.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Meet the Team",
        "item": "https://monkstack.com/meet-the-team"
      }
    ]
  };

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Meet the Team - monkStack",
    "description": "Meet the talented team behind monkStack - AI & Engineering Solutions.",
    "url": "https://monkstack.com/meet-the-team"
  };

  return (
    <div className="App">
      <SEO
        title="Meet the Team"
        description="Meet the talented team behind monkStack - AI & Engineering Solutions. Learn about our founders, engineers, and AI/ML experts."
        url="https://monkstack.com/meet-the-team"
        structuredData={[breadcrumbSchema, aboutPageSchema]}
        noindex={true}
      />
      <Navbar />
      <section id="meet-the-team" className="team-section" ref={sectionRef}>
        <div className="container">
          <h2 className="section-title">Meet the Team</h2>
          <div className="coming-soon-container">
            <p className="coming-soon-text">Coming Soon</p>
          </div>
          {/* <div className="team-grid" style={{ display: 'none' }}>
            {teamMembers.map((member, index) => (
              <div key={index} className="team-member-card">
                <div className="team-member-image">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="team-member-image-fallback" style={{ display: 'none' }}>
                    <span>{member.name.charAt(0)}</span>
                  </div>
                </div>
                <div className="team-member-info">
                  <h3 className="team-member-name">{member.name}</h3>
                  <p className="team-member-role">{member.role}</p>
                  <p className="team-member-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default MeetTheTeamPage;

